import { TransferReviewDetails } from '@varo/graphql-schema-types';
import TransferReviewSections from 'features/feeBasedInstantTransfer/components/TransferReviewSections/TransferReviewSections';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import Button from 'shared/components/vxl/Button/Button';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import theme from 'shared/styles/theme';

const DISCLAIMER_MAX_FONT_SIZE_MULTIPLIER = 1.5;

interface ReadyTransferReviewProps {
  review: TransferReviewDetails;
  isSubmitting: boolean;
  onSubmit: () => Promise<void>;
}

function ReadyTransferReview({
  review,
  isSubmitting,
  onSubmit,
}: ReadyTransferReviewProps) {
  const { t } = useTranslation('feeBasedInstantTransfer');

  return (
    <>
      <TransferReviewSections
        accessibilityLabel={t('review.details')}
        sections={review.sections}
        header={
          <TitleLgText
            numberOfLines={0}
            accessibilityRole="header"
            style={styles.title}
          >
            {review.title}
          </TitleLgText>
        }
      />
      <View style={styles.footer}>
        <BodyXSText
          numberOfLines={0}
          maxFontSizeMultiplier={DISCLAIMER_MAX_FONT_SIZE_MULTIPLIER}
          style={styles.disclaimer}
        >
          {review.disclaimer}
        </BodyXSText>
        <Button
          label={t('review.submit')}
          isLoading={isSubmitting}
          isDisabled={isSubmitting}
          onPress={() => {
            void onSubmit();
          }}
        />
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  title: {
    paddingHorizontal: theme.spacing.m,
    paddingBottom: theme.spacing.m,
  },
  footer: { padding: theme.spacing.m },
  disclaimer: {
    color: theme.color.text.secondary,
    marginBottom: theme.spacing.l,
  },
});

export default ReadyTransferReview;
